import React from 'react';
import { Box, Button, Divider, Icon, IconButton, Paper, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Add, ArrowBack, Article, Balance, CommentBank, Search } from '@mui/icons-material';

import { useNavigate, useParams } from 'react-router-dom';
import { Environment } from '../../../environment';

interface IToolsDamInformationProps {
    showSearch?: boolean;
    showLegislation?: boolean;
    showPsb?: boolean;
    showSecurityPlan?: boolean;
    showNaviButton?: boolean;

    showNew?: boolean;
    onClickNew?: () => void;
}


export const ToolsDamInformation:React.FC<IToolsDamInformationProps> = ({
    // showSearch = true,
    // showNew= false,
    showLegislation = true,
    showSecurityPlan = true,
    showNaviButton = true,
    showPsb = true,

    onClickNew,
}) => {
    const { id } = useParams();
    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();
    function lastUrl() {
        window.history.back();
    }    

    return (
        <Box 
            component={Paper}
            height={theme.spacing(4)}
            marginX={1}
            paddingX={2}
            padding={1}
            display={'flex'}
            flexDirection={'row'}
            gap={1}
            alignItems={'center'}
            borderRadius={2}
            // alignContent={'center'}
        >
            {/* {(showSearch && !smDown) &&(
                <>
                    <TextField

                        size='small'
                        placeholder={Environment.INPUT_DE_BUSCA}
                    />
                    <IconButton>
                        <Search />
                    </IconButton>
                    <Divider
                        color='primary'
                        orientation="vertical" variant="fullWidth" flexItem
                    />
                    <></>
                </>

            )}

            <Box flex={1} display={'flex'} justifyContent={'start'} gap={1} marginLeft={2}>
               {showNew && (
                <>
                    <Button
                        onClick={onClickNew}
                        variant='contained'
                        disableElevation
                        endIcon={<Add/>}
                    >
                        Novo
                    </Button>
                </>
               )}
            </Box> */}

            <Box flex={1} display={'flex'} justifyContent={smDown? 'space-between' : 'end'} gap={1} marginLeft={2}>
            {showLegislation && (
                <>
                    {smDown? <>
                    <IconButton
                        color='primary'
                        size='medium'
                        onClick={() => navigate('/legislation')}
                    >
                        <Balance/>
                    </IconButton>
                    
                    </> : <>
                        <Button 
                            variant='contained'
                            color='primary'
                            size='medium'
                            onClick={() => navigate('/legislation')}
                            startIcon={<Balance/>}
                            sx={{borderRadius: '25px'}}
                        >
                            <Typography
                                variant='button'
                                whiteSpace={'nowrap'}
                                textOverflow={'ellipsis'}
                                overflow={'hidden'}
                            >
                                Legislação

                            </Typography>
                        </Button>
                    </>}
                    
                </>
               )}

            {showPsb && (
                <>
                    {smDown? <>
                    <IconButton
                        color='primary'
                        size='medium'
                        onClick={() => navigate('./psb')}
                    >
                        <Article/>
                    </IconButton>
                    
                    </> : <>
                        <Button 
                            variant='contained'
                            color='primary'
                            size='medium'
                            onClick={() => navigate(`/information_dam/${id}/psb`)}
                            startIcon={<Article/>}
                            sx={{borderRadius: '25px'}}
                        >
                            <Typography
                                variant='button'
                                whiteSpace={'nowrap'}
                                textOverflow={'ellipsis'}
                                overflow={'hidden'}
                            >
                                Gerar PSB

                            </Typography>
                        </Button>
                    </>}
                    
                </>
               )}


               {showSecurityPlan && (
                <>
                    {/* {smDown? <>
                        <IconButton
                            color='primary'
                            size='small'
                        >
                            <CommentBank/>
                        </IconButton>
                    </> : <>
                        <Button
                            variant='outlined'
                            color='primary'
                            size='small'
                            startIcon={<CommentBank/>}
                            sx={{borderRadius: '25px'}}
                        >
                            <Typography 
                                variant='button'
                                whiteSpace={'nowrap'}
                                textOverflow={'ellipsis'}
                                overflow={'hidden'}
                            >
                                Plano de comunicação
                            </Typography>
                        </Button>
                    </>} */}
                </>
               )}  
                {(showNaviButton) &&(
                    <>
                        {smDown? <>
                            <IconButton
                                size='small'
                                onClick={() => lastUrl()}
                            >
                                <ArrowBack/>
                            </IconButton>
                        </>:<>
                            <Button
                                variant='outlined'
                                disableElevation
                                startIcon={<ArrowBack/>}
                                size='small'
                                onClick={() => lastUrl()}
                                sx={{borderRadius: '25px'}}
                            >
                                <Typography
                                    variant='button'
                                    whiteSpace={'nowrap'}
                                    textOverflow={'ellipsis'}
                                    overflow={'hidden'}
                                >
                                    Voltar
                                </Typography>
                            </Button>
                        </>}
                    </>    
                )}
            </Box>

        </Box>
    );
};